import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Clover, KeyRound } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";

const field =
  "w-full bg-[#0F1812] border border-[#00E676]/20 rounded-lg px-4 py-3 text-white placeholder-[#697C6F] focus:outline-none focus:ring-2 focus:ring-[#39FF14]";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Les mots de passe ne correspondent pas");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Mot de passe réinitialisé !");
      setTimeout(() => navigate("/login"), 1800);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#0B120E] ant-radial p-6">
      <div className="w-full max-w-md ant-in">
        <div className="flex items-center gap-2 justify-center mb-8 text-[#39FF14]">
          <Clover className="fill-[#39FF14]" />
          <span className="font-script text-3xl">A Nous Turf</span>
        </div>
        <div className="rounded-xl border border-[#00E676]/15 bg-[#131F17] p-8">
          <div className="flex items-center gap-2 mb-1">
            <KeyRound className="text-[#00E676]" size={20} />
            <h1 className="text-2xl font-bold">Nouveau mot de passe</h1>
          </div>

          {!token ? (
            <p className="text-sm text-[#FF3B30] mt-3">Lien invalide : aucun jeton fourni. Refaites une demande depuis la page de connexion.</p>
          ) : done ? (
            <p className="text-sm text-[#39FF14] mt-3">Votre mot de passe a été mis à jour. Redirection vers la connexion…</p>
          ) : (
            <form onSubmit={submit} className="space-y-4 mt-4" data-testid="reset-form">
              <input className={field} type="password" placeholder="Nouveau mot de passe" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" />
              <input className={field} type="password" placeholder="Confirmer le mot de passe" required value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm" />
              <button type="submit" disabled={loading} data-testid="reset-submit" className="w-full flex items-center justify-center gap-2 py-3.5 rounded-lg font-bold text-[#04180a] bg-gradient-to-r from-[#00E676] to-[#39FF14] disabled:opacity-60">
                {loading ? <Loader2 className="animate-spin" size={18} /> : "Réinitialiser mon mot de passe"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
